export default function initializeGTM(): void {
  const gtmId: string | undefined = import.meta.env.VITE_ICE_GTM_ID as string | undefined

  if (gtmId) {
    if (document.querySelector(`script[src="https://www.googletagmanager.com/gtm.js?id=${gtmId}"]`)) {
      return
    }

    const script = document.createElement('script')
    script.async = true
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');`

    document.head.appendChild(script)
    window.dataLayer = window.dataLayer || []
  }
}
